import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Props from '@/components/shared/components/add-to-cart-button/add-to-cart-modal/product-summary/type';
import PriceView from '@/components/shared/components/price-view';

import { DATA_CY_ADD_TO_CARD_POP_UP_HEADER } from '@/constant/cypress';
export default function ProductSummary({
  icon,
  title,
  storeName,
  price,
  lastPrice,
  discount,
  saleEndedAt,
  finalPrice = 0,
  isOnSale,
  showDiscountWithoutExpiration,
}: Props) {
  const finalDiscount = isOnSale ? discount : 0;

  return (
    <Container
      data-cy={DATA_CY_ADD_TO_CARD_POP_UP_HEADER}
      center
      className='flex-wrap justify-between gap-1 py-4 md:flex-nowrap md:gap-2'
    >
      <Container center className='gap-[13px]'>
        <XImage src={icon.publicLink} alt={icon.title} width={60} height={60} />

        <Container>
          <Text className='line-clamp-2'>{title}</Text>
          <Text className='hidden text-[13px] text-[#76767C] md:inline'>{storeName}</Text>
        </Container>
      </Container>
      <Container className='-mt-0.5 flex w-full flex-wrap items-center justify-between gap-1 md:w-fit'>
        <Text className='inline pr-[25%] text-[13px] text-[#76767C] md:hidden'>
          {storeName}
        </Text>

        <PriceView
          price={finalPrice ? finalPrice : price}
          lastPrice={lastPrice}
          discount={finalDiscount}
          saleEndedAt={saleEndedAt}
          showDiscountWithoutExpiration={showDiscountWithoutExpiration}
          priceWrapperClassName='flex gap-[5px]'
          regularPrice={lastPrice}
          className='ms-auto!'
        />
      </Container>
    </Container>
  );
}
